import React, {useContext, useEffect, useState} from 'react';
import {Dropdown, Form, Spinner} from "react-bootstrap";
import {editGenre, fetchGenre} from "../../../http/bookAPI";
import Modal from "react-bootstrap/Modal";
import {Context} from "../../../index";
import {observer} from "mobx-react-lite";

const EditGenre = observer(({ show, handleClose }) => {
    const {book} = useContext(Context)
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchGenre().then(data => book.setGenres(data))
    }, []);

    const modifyGenre = async () => {
        if (!book.selectedGenre.id) {
            setError('Please select a genre to modify.');
            return;
        }

        setLoading(true);
        setError('');
        try {
            // Логируем id и данные, которые отправляются в запросе
            console.log('Deleting genre with id:', book.selectedGenre.id);
            console.log('Genre data being sent:', { id: book.selectedGenre.id, genre: value });
            await editGenre({
                id: book.selectedGenre.id, // Используем выбранный жанр
                genre: value //// Новое название жанра

            });
            const updatedGenres = await fetchGenre(); // Обновляем список жанров после изменения
            book.setGenres(updatedGenres);
            book.setSelectedGenre({}); // Сбрасываем выбранный жанр
            setValue(''); // Очищаем поле ввода
            handleClose(); // Закрываем модальное окно
        } catch (e) {
            const errorMessage = e.response?.data?.message || 'An error occurred while modifying the genre.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Modal show={show} onHide={() => {
            setError('');
            handleClose();
        }} centered>

            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Edit Genre</h1>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                    ></button>
                </div>

                <div className="card">
                    <div className="card-body">

                        <div className="d-flex justify-content-center mt-3">

                            <Dropdown className="dropdown-center">
                                <Dropdown.Toggle variant="success" className="shadow">
                                    {book.selectedGenre.genre || "Select Genre to Modify"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {book.genres.map((gen) => (
                                        <Dropdown.Item
                                            onClick={() => {book.setSelectedGenre(gen);
                                            setValue(gen.genre);
                                            }}
                                            key={gen.id}
                                        >
                                            {gen.genre}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <div className="modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form>
                        <Form.Control
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            placeholder="Enter new name for the genre"
                            disabled={loading || !book.selectedGenre.genre} // Отключаем, если ничего не выбрано
                        />
                    </Form>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={modifyGenre}
                        disabled={!value.trim() || loading}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Rewrite in DB'}
                    </button>

                </div>
            </div>
        </Modal>
    );
});

export default EditGenre;
